module.exports = __webpack_public_path__ + "img/home_sub_title.d756272c.png";